import { signal } from "@preact/signals-react"

export const sellerDeepDiveOffersFilters = signal({})
export const sellerDeepDiveOffersCurrentPeriod  = signal("")
export const sellerDeepDiveChartActualPrice  = signal(true)
export const sellerDeepDiveEndDate = signal("")